import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Axios from "axios";
import Web3 from "web3";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

import AdminSideBar from "../../Components/Admin/AdminSideBar";
import GlobalContext from "../../Hooks/globalContext";
import { NODE_ENDPOINT } from "../../Utils/constants";
import "../../Styles/pagination.css";
import useState from "../../Hooks/useState";
import languagePack from "../../Utils/language";
import AdminHeader from "../../Components/Admin/AdminHeader";
import RegisterProduct from "../../Components/Admin/Pages/RegisterProduct";

import UserPage from "../../Components/Admin/Pages/UserPage";
import LogPage from "../../Components/Admin/Pages/LogPage";
import ConfigPage from "../../Components/Admin/Pages/ConfigPage";
import ExcelLockup from "../../Components/Admin/Pages/ExcelLockup";

// import WithdrawPage from "../../Components/Admin/Pages/WithdrawPage";
// import PushPage from "../../Components/Admin/Pages/PushPage";
// import InputPage from "../../Components/Admin/Pages/InputPage";
// import MatchingLogPage from "../../Components/Admin/Pages/MatchingLogPage";
// import NoticePage from "../../Components/Admin/Pages/NoticePage";
// import WritePage from "../../Components/Admin/Pages/WritePage";

const Admin = styled.div`
  display: flex;
  height: 100%;
`;

const Main = styled.div`
  width: calc(100% - 250px);
  background-color: ${(props) => props.theme.lightGrey};
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: calc(100% - 90px);
  padding: 0px 20px 20px 20px;
`;

const Content = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
`;

const Container = ({ history, location }) => {
  const { isLogin, user, getUser, logout, language } = useContext(GlobalContext);
  const page = useState("userList");
  const focus = useState(null);
  const preload = async () => {
    const _user = await getUser();
    if (_user === "expired") {
      return;
    }
    if (_user.isAdmin === 0) {
      logout();
    }
  };

  useEffect(() => {
    if (page.state !== "registerProduct") {
      focus.setState(null);
    }
  }, [page.state]);

  useEffect(() => {
    preload();
  }, []);

  return (
    <Admin>
      {user.state && (
        <>
          <Helmet>
            <title>ADMIN</title>
          </Helmet>
          <AdminSideBar page={page} />
          <Main>
            <AdminHeader page={page.state} setPage={page.setState} />
            <ContentWrapper>
              <Content>
                {page.state === "userList" && <UserPage adminPage={page} hostPath={"/admin/users"} />}
                {page.state === "lockupList" && (
                  <LogPage
                    adminPage={page}
                    tableName="lockup_list"
                    columnName="lockupList"
                    columnList="lockList"
                    searchList={[
                      ["t.id", "번호"],
                      ["t.user_id", "유저 번호"],
                      ["u.email", "이메일"],
                      ["LOWER(u.eth_wallet_address)", "지갑주소"],
                    ]}
                  />
                )}
                {page.state === "stakingList" && (
                  <LogPage
                    adminPage={page}
                    tableName="staking"
                    columnName="stakingList"
                    searchList={[
                      ["t.id", "번호"],
                      ["t.user_id", "유저 번호"],
                      ["t.status", "유저 번호" + `(0:${"미지급"}, 1:${"지급"})`],
                    ]}
                  />
                )}
                {page.state === "mallList" && (
                  <LogPage
                    rootParams={{ focus }}
                    adminPage={page}
                    tableName="mall_product"
                    columnName="mallList"
                    condition="is_delete = 'N'"
                    columnList="mallList"
                    searchList={[
                      ["t.id", "번호"],
                      ["t.user_id", "유저 번호"],
                    ]}
                  />
                )}
                {page.state === "mallOrder" && (
                  <LogPage
                    rootParams={{ focus }}
                    adminPage={page}
                    tableName="mall_order"
                    columnName="mallOrder"
                    // condition="is_delete = 'N'"
                    columnList="mallOrder"
                    searchList={[
                      ["t.id", "번호"],
                      ["t.user_id", "유저 번호"],
                    ]}
                  />
                )}
                {page.state === "registerProduct" && <RegisterProduct adminPage={page} focus={focus} />}
                {page.state === "config" && <ConfigPage adminPage={page} />}
                {page.state === "excelLockup" && <ExcelLockup adminPage={page} />}

                {/* {page.state === "chargeLog" && <ChargeLogPage adminPage={page} hostPath={"/admin/log/charge"} />}
                {page.state === "sendLog" && <SendLogPage adminPage={page} hostPath={"/admin/log/send"} />}
                {page.state === "matchingLog" && <MatchingLogPage adminPage={page} hostPath={"/admin/log/matching"} />}
                {page.state === "withdraw" && <WithdrawPage adminPage={page} hostPath={"/admin/withdraw"} />}
                {page.state === "noticeList" && (
                  <NoticePage adminPage={page} focus={focus} hostPath={"/admin/notice/list"} />
                )}
                {page.state === "noticeWrite" && <WritePage adminPage={page} hostPath={"/admin/notice/crud"} />}
                {page.state === "noticeUpdate" && (
                  <WritePage adminPage={page} type="update" focus={focus} hostPath={"/admin/notice/crud"} />
                )}
                {page.state === "push" && <PushPage adminPage={page} />}
                {page.state === "input" && <InputPage adminPage={page} />}
                {page.state === "qna" && <QnaPage adminPage={page} hostPath={"/admin/qna"} />} */}
              </Content>
            </ContentWrapper>
          </Main>
        </>
      )}
    </Admin>
  );
};

export default Container;
